import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthOperatorService } from 'src/app/services/auth-operator.service';

@Component({
  selector: 'app-toolbar-operator',
  templateUrl: './toolbar-operator.component.html',
  styleUrls: ['./toolbar-operator.component.scss']
})
export class ToolbarOperatorComponent implements OnInit {
  @Input() drawer;

  constructor(
    private auth: AuthOperatorService,
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  public logout() {
    this.auth.logout();
    this.router.navigate(['/operador/login']);
  }

}
